import { UserRole } from '../constants/constants';
import { store } from '../../index';

export class UserHelpers {
  static checkPermissions(roles: UserRole[]): boolean {
    const authData: IAuthInfo | null = store && store.getState().app.authInfo.data;
    return !!authData && authData.role && roles.includes(authData.role);
  }
}
